import Image from 'next/image';
import { FC, JSX, MouseEventHandler } from 'react';

export enum ButtonVariants {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  OUTLINED = 'OUTLINED',
}

export const buttonLoadingElement = (
  <Image
    src={'/images/button-v2-loader.gif'}
    width={38}
    height={38}
    alt="Loading..."
    className="mx-auto"
  />
);

type ButtonV2Props = {
  /**
   * This props is used for the text to be displayed inside the button
   */
  children: JSX.Element | string;
  /**
   * This props is used for the variant of the button
   */
  variant?: ButtonVariants;
  /**
   * This props is used determine if the button is disabled
   */
  disabled?: boolean;
  /**
   * This props is used determine if the button is in loading state
   */
  loading?: boolean;
  /**
   * This props is used for button click handler
   */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /**
   * This props is used to determined if the button text willbe underlined
   */
  underlined?: boolean;
  className?: string;
};

const ButtonV2: FC<ButtonV2Props> = ({
  children,
  disabled = false,
  variant = ButtonVariants.PRIMARY,
  onClick = () => {},
  underlined = false,
  loading = false,
  className = '',
}) => {
  const variantClasses = {
    [ButtonVariants.PRIMARY]:
      'bg-[#212121] disabled:bg-[#757575] text-white h-[48px] px-[20px]',
    [ButtonVariants.SECONDARY]:
      'bg-transparent disabled:text-[#757575] text-[#212121] py-[15px]',
    [ButtonVariants.OUTLINED]:
      'bg-transparent border-[#E0E0E0] border text-[#212121] py-[15px]',
  };
  return (
    <button
      onClick={onClick}
      aria-label="Button"
      disabled={disabled || loading}
      className={`w-fit ${variantClasses[variant]} rounded-[8px] text-15 ${
        underlined ? 'underline' : ''
      } ${className}`}
    >
      {loading ? buttonLoadingElement : children}
    </button>
  );
};

export default ButtonV2;
